import React from 'react';
import { Row, Col, Form, Input, Button, notification } from 'antd';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthFormWrap } from './style';
import { DataService } from '../../../../config/dataService/dataService';

function SetPassword() {
  const navigate = useNavigate();
  const { token, email } = useParams();

  const handleSubmit = async (values) => {
    try {
      const payload = {
        email,
        token,
        password: values.password,
        password_confirmation: values.password_confirmation,
      };

      const response = await DataService.post('/v1/auth/set-password', payload, { Authorization: '' });
      if (response.data.success === true) {
        notification.success({
          message: 'Set Password',
          description: 'Your password has been set successfully.',
        });
        setTimeout(() => {
          navigate('/');
        }, 800);
      }
    } catch (error) {
      notification.error({
        message: 'Set Password',
        description: error.response?.data?.message || 'Something went wrong.',
      });
    }
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>TC101 | Set Password</title>
      </Helmet>
      <Row justify="center">
        <Col xxl={6} xl={8} md={12} sm={18} xs={24}>
          <AuthFormWrap>
            <Form name="setPass" onFinish={handleSubmit} layout="vertical">
              <div className="ninjadash-authentication-top">
                <h2 className="ninjadash-authentication-top__title">Set Password</h2>
              </div>
              <div className="ninjadash-authentication-content">
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true, message: 'Please enter a password.' }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="password_confirmation"
                  label="Confirm Password"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: 'Please confirm your password.' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) return Promise.resolve();
                        return Promise.reject(new Error('Passwords do not match.'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item>
                  <div className="setting-form-actions">
                    <Button htmlType="submit" type="primary">
                      Set Password
                    </Button>
                    &nbsp; &nbsp;
                    <Button size="default" onClick={handleCancel} type="light">
                      Cancel
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </AuthFormWrap>
        </Col>
      </Row>
    </>
  );
}

export default SetPassword;
